<h4 mat-dialog-title>{{ dialogData?.tenant ? "Edit" : "Add" }} tenant</h4>

<mat-dialog-content>
  @if (!loading) {
    <mat-tab-group [formGroup]="form">
      <mat-tab [label]="'General'">
        <div class="form">
          <mat-form-field>
            <mat-label>ID</mat-label>
            <input
              matInput
              type="text"
              formControlName="id"
              [readonly]="!!dialogData?.tenant"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput type="text" formControlName="name" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Features</mat-label>
            <mat-select multiple formControlName="features">
              @for (feature of features; track feature) {
                <mat-option [value]="feature">{{ feature }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Toggles</mat-label>
            <mat-select multiple formControlName="toggles">
              @for (toggle of toggles; track toggle) {
                <mat-option [value]="toggle">{{ toggle }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Tenant languages</mat-label>
            <mat-select multiple formControlName="languages">
              @for (language of languages; track language) {
                <mat-option [value]="language">{{ language }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Default language</mat-label>
            <mat-select formControlName="defaultLanguage">
              @for (language of languages; track language) {
                <mat-option [value]="language">{{ language }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!dialogData?.tenant) {
            <div class="admin-data" formGroupName="admin">
              <h6>Admin user</h6>
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput type="text" formControlName="email" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>First name</mat-label>
                <input matInput type="text" formControlName="firstName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Last name</mat-label>
                <input matInput type="text" formControlName="lastName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Language</mat-label>
                <mat-select formControlName="language">
                  @for (language of languages; track language) {
                    <mat-option [value]="language">{{ language }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Rules</mat-label>
                <mat-select multiple formControlName="rules">
                  @for (rule of rules; track rule) {
                    <mat-option [value]="rule">{{ rule }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab [label]="'Config'">
        <div class="form" formGroupName="fseekConfig">
          <h6 class="form-title">Frameseek settings</h6>
          <mat-form-field>
            <mat-label>Tenant name</mat-label>
            <input matInput type="text" formControlName="tenantName" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Quota</mat-label>
            <input matInput type="number" formControlName="quota" />
          </mat-form-field>
        </div>
        <div class="form" formGroupName="fprintConfig">
          <h6 class="form-title">Fingerprint settings</h6>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>API Key</mat-label>
            <input matInput type="text" formControlName="apiKey" />
          </mat-form-field>
        </div>
        <div class="form" formGroupName="lythoConfig">
          <h6 class="form-title">Lytho settings</h6>
          <mat-form-field>
            <mat-label>API Key</mat-label>
            <input matInput type="text" formControlName="apiKey" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Lytho URL</mat-label>
            <input matInput type="text" formControlName="lythoUrl" />
          </mat-form-field>
        </div>
        <div class="form" formGroupName="bynderConfig">
          <h6 class="form-title">Bynder settings</h6>
          <mat-form-field>
            <mat-label>Client ID</mat-label>
            <input matInput type="text" formControlName="clientId" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Client Secret</mat-label>
            <input matInput type="text" formControlName="clientSecret" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Bynder URL</mat-label>
            <input matInput type="text" formControlName="bynderUrl" />
          </mat-form-field>
          <mat-checkbox formControlName="waitingRoom"
            >Waiting Room Mode</mat-checkbox
          >
        </div>
        <div class="form" formGroupName="mediafilerConfig">
          <h6 class="form-title">Mediafiler settings</h6>
          <mat-form-field>
            <mat-label>API Key</mat-label>
            <input matInput type="text" formControlName="apiKey" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>API User</mat-label>
            <input matInput type="text" formControlName="apiUser" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Mediafiler URL</mat-label>
            <input matInput type="text" formControlName="mediafilerUrl" />
          </mat-form-field>
        </div>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <lib-spinner></lib-spinner>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="secondary" (click)="onClose()">Cancel</button>
  <button mat-flat-button (click)="onSave()" [disabled]="form.invalid">
    {{ dialogData?.tenant ? "Update" : "Add" }}
  </button>
</mat-dialog-actions>
